import { useQuery } from "@tanstack/react-query";
import { contractorDetailsApi } from "../api/contractorApi";

export const useFetchRiskAndWarning = (contractorId: string | null) => {

    const { data, isFetching, isPending, isError, error, refetch } = useQuery({
        queryKey: ["contractor-risk-and-warning", contractorId],
        queryFn: () => contractorDetailsApi.fetchRiskAndWarning(contractorId),
        enabled: !!contractorId,
    });

    return {
        data: data,
        isLoading: isFetching || isPending,
        isError,
        error,
        refetch,
    };

};